import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';

import { queryClient } from '@queries';

import App from './app/app';
import { ErrorFallback } from './components/ErrorFallback/ErrorFallback';

if (!import.meta.env.DEV) {
    Sentry.init({
        dsn: import.meta.env['VITE_PUBLIC_SENTRY_DSN'],
        integrations: [Sentry.replayIntegration()],
        sendDefaultPii: true,
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
    });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Sentry.ErrorBoundary fallback={ErrorFallback} onReset={() => window.location.reload()}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <App />
                <Toaster position="bottom-right" richColors closeButton />
            </BrowserRouter>
        </QueryClientProvider>
    </Sentry.ErrorBoundary>,
);
